import {createRouter, createWebHistory} from 'vue-router'
import Home from "@/components/pages/Home.vue";
import CheckInIndex from "@/components/pages/checkin/Index.vue";
import CheckOutIndex from "@/components/pages/checkout/Index.vue";
import FinishIndex from "@/components/pages/finish/Index.vue";


const routes = [
    {
        path: '/',
        redirect: {path: "/home"},
        meta: {
            permission: []
        }
    },

    {
        path: '/home',
        component: Home,
        name: 'home',
        meta: {
            permission: [],
            title: 'Trang chủ'
        }
    },
    {
        path: '/check-in',
        component: CheckInIndex,
        name: 'check_in_index',
        meta: {
            permission: [],
            title: 'Check In'
        }
    },
    {
        path: '/check-out',
        component: CheckOutIndex,
        name: 'check_out_index',
        meta: {
            permission: [],
            title: 'Check In'
        }
    },
    {
        path: '/finish',
        component: FinishIndex,
        name: 'finish_index',
        meta: {
            permission: [],
            title: 'Finish'
        }
    },
];


const router = createRouter({
    history: createWebHistory(),
    routes: routes
})

router.beforeEach((to, from, next) => {
    //todo: Kiểm tra quyền và điều hương tại đây.
    next();
})

export default router



